<terra-3-col [leftColumnWidth]="2" [rightColumnWidth]="_rightColumnWidth" [centerColumnWidth]="_centerColumnWidth">
    <mat-tree terraTree left [dataSource]="_dataSource" [treeControl]="_treeControl">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
            <li
                class="mat-tree-node"
                [class.active]="_currentSelectedNode.key === node.key"
                (click)="_onNodeClick($event, node)"
            >
                <mat-icon
                    *ngIf="node.icon"
                    class="node-icon icon"
                    fontSet="plentyicons"
                    [fontIcon]="node.icon"
                ></mat-icon>
                {{ node.name }}
            </li>
        </mat-tree-node>
        <mat-nested-tree-node *matTreeNodeDef="let node; when: _hasChild">
            <li (click)="_onNodeClick($event, node)">
                <div class="mat-tree-node" [class.active]="_currentSelectedNode.key === node.key">
                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{ _treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                        </mat-icon>
                    </button>
                    <mat-icon
                        *ngIf="node.icon"
                        class="node-icon icon"
                        fontSet="plentyicons"
                        [fontIcon]="node.icon"
                    ></mat-icon>
                    {{ node.name }}
                </div>
                <ul [class.mat-nested-tree-invisible]="!_treeControl.isExpanded(node)">
                    <ng-container matTreeNodeOutlet></ng-container>
                </ul>
            </li>
        </mat-nested-tree-node>
    </mat-tree>
    <terra-file-list
        center
        #fileList
        [inputStorageServices]="inputStorageServices"
        (showImagePreview)="_showImagePreview($event)"
        (hideImagePreview)="_hideImagePreview()"
        (selectNode)="selectNode($event)"
    >
    </terra-file-list>
    <terra-image-preview
        right
        [inputStorageService]="fileList.activeStorageService"
        [inputStorageObject]="fileList.imagePreviewObject"
    >
    </terra-image-preview>
</terra-3-col>
